import { useEffect, useState } from 'react'
import { VIDEO } from '../data/dgpt'

type OEmbedResponse = { thumbnail_url?: string }

/**
 * Resolves a high-resolution Vimeo poster frame via oEmbed (a small JSON
 * request — the Vimeo player itself is not loaded). A hosted `posterLocal`
 * takes priority and skips the request entirely.
 */
export function useVimeoPoster(): string | null {
  const [poster, setPoster] = useState<string | null>(VIDEO.posterLocal || null)

  useEffect(() => {
    if (VIDEO.posterLocal) return
    const controller = new AbortController()
    fetch(VIDEO.oembedUrl, { signal: controller.signal })
      .then((response) => (response.ok ? (response.json() as Promise<OEmbedResponse>) : null))
      .then((data) => {
        if (!data?.thumbnail_url) return
        // Request a 1920×1080 frame so the poster stays crisp on Retina screens.
        const hiRes = data.thumbnail_url.replace(/_\d+x\d+(?=[^/]*$)/, '_1920x1080')
        setPoster(hiRes)
      })
      .catch(() => {
        /* Falls back to the dark poster surface. */
      })
    return () => controller.abort()
  }, [])

  return poster
}
